import { judgeService } from "../_services";

let status = {
  INITIAL: 0,
  LOADING: 1,
  LOADED: 2
}

export default {
  namespaced: true,


  state: {
    currentJudge: '',
    judges: {
      list: [],
      status: status.INITIAL
    },
    caseTypes: {
      list: [],
      status: status.INITIAL
    },
    holidayTypes: {
      list: [],
      status: status.INITIAL
    },
    specialisationTypes: {
      list: [],
      status: status.INITIAL
    },
    selectedType: null,
    selectedCourt: null,
    selectedArchive: {title: "активные", value: false}
  },

  getters: {
    judgeFullName: state => {
      if (state.currentJudge) {
        let { lastName, firstName, middleName } = state.currentJudge
        return `${lastName} ${firstName ? firstName.slice(0,1) + '.' : ''} ${middleName ? middleName.slice(0,1) + '.' : ''} ` 
      }
      return ''
    },

    judges: ({ judges }) => judges.list.sort((a, b) => { if (a.lastName!=null) a.lastName.localeCompare(b.lastName) }),
    judgesActive: ({ judges }) => judges.list.filter(judge => !judge.archive).sort((a, b) => a.lastName.localeCompare(b.lastName)),
    isJudgesLoaded: ({ judges }) => judges.status == status.LOADED,

    caseTypes: ({ caseTypes }) => caseTypes.list.filter(item => item.value!=3),
    isCaseTypesLoaded: ({ caseTypes }) => caseTypes.status == status.LOADED,

    holidayTypes: ({ holidayTypes }) => holidayTypes.list.filter(item => item.value > 1),
    isHolidayTypesLoaded: ({ holidayTypes }) => holidayTypes.status == status.LOADED,

    specialisationTypes: ({ specialisationTypes }) => specialisationTypes.list,
    isSpecialisationTypesLoaded: ({ specialisationTypes }) => specialisationTypes.status == status.LOADED,
  },
  mutations: {
    setCurrentJudge: (state, payload) => {
      state.currentJudge = payload
    },

    setJudges: ({ judges }, payload) => {
      judges.list = payload
    },
    setJudgesStatus: ({ judges }, status) => {
      judges.status = status
    },
    setJudgeInJudges: (state, judge) => {
        let curr = state.judges.list.filter(item => item.id == judge.id)[0]
        if (curr !== undefined) Object.assign(curr, judge)
    },
    addJudgeInJudges: (state, judge) => {
      state.judges.list.push(judge)
    },

    setcCaseTypes: ({ caseTypes }, payload) => {
      caseTypes.list = payload
    },
    setCaseTypesStatus: ({ caseTypes }, status) => {
      caseTypes.status = status
    },

    setHolidayTypes: ({ holidayTypes }, payload) => {
      holidayTypes.list = payload
    },
    setHolidayTypesStatus: ({ holidayTypes }, status) => {
      holidayTypes.status = status
    },

    setSpecialisationTypes: ({ specialisationTypes }, payload) => {
      specialisationTypes.list = payload
    },
    setSpecialisationTypesStatus: ({ specialisationTypes }, status) => {
      specialisationTypes.status = status
    },

    selectType: ( state , type) => {
      state.selectedType = type
    },

    selectArchive: ( state , type) => {
      state.selectedArchive = type
    },

    selectCourt: ( state , type) => {
      state.selectedCourt = type
    }
  },
  actions: {
    INIT: ({ dispatch }, { judgeId }) => {
      dispatch('LOAD_JUDGE', judgeId)
      dispatch('LOAD_CASE_TYPES')
      dispatch('LOAD_HOLIDAY_TYPES')
      dispatch('LOAD_SPECIALISATION_TYPES')
    },

    LOAD_JUDGE: ({ commit }, judgeId) => {
      judgeService.judge(judgeId)
      .then(data => {
        commit('setCurrentJudge', data)
      })
    } ,

    INIT_JUDGES: ({ dispatch }) => {
      dispatch('LOAD_JUDGES')
      dispatch('LOAD_CASE_TYPES')
      dispatch('LOAD_HOLIDAY_TYPES')
      dispatch('LOAD_SPECIALISATION_TYPES')
    },  

    LOAD_JUDGES: ({ state, commit }) => {
      if (state.judges.status == status.INITIAL) {
        commit('setJudgesStatus', status.LOADING)
        judgeService.list().then(data => {
          commit('setJudges', data)
          commit('setJudgesStatus', status.LOADED)
        })
      }
    },

    LOAD_CASE_TYPES: ({ state, commit }) => {
      if (state.caseTypes.status == status.INITIAL) {
        commit('setCaseTypesStatus', status.LOADING)
        judgeService.getCaseTypes().then(data => {
          commit('setcCaseTypes', data)
          commit('setCaseTypesStatus', status.LOADED)
        })
      }
    },

    LOAD_HOLIDAY_TYPES: ({ state, commit }) => {
      if (state.holidayTypes.status == status.INITIAL) {
        commit('setHolidayTypesStatus', status.LOADING)
        judgeService.getHolidayType().then(data => {
          commit('setHolidayTypes', data)
          commit('setHolidayTypesStatus', status.LOADED)
        })
      }
    },

    LOAD_SPECIALISATION_TYPES: ({ state, commit }) => {
      if (state.specialisationTypes.status == status.INITIAL) {
        commit('setSpecialisationTypesStatus', status.LOADING)
        judgeService.getSpecializationTypes().then(data => {
          commit('setSpecialisationTypes', data)
          commit('setSpecialisationTypesStatus', status.LOADED)
        })
      }
    },
  }
}